import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import MobileNav from '../../components/feature/MobileNav';
import LanguageSwitcher from '../../components/feature/LanguageSwitcher';
import { supabase } from '../../lib/supabase';

interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  category: string;
  image: string;
  stock: number;
  rating: number;
}

export default function Home() {
  const { t } = useTranslation();
  const [featuredShoes, setFeaturedShoes] = useState<Product[]>([]);
  const [featuredDrinks, setFeaturedDrinks] = useState<Product[]>([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const { data: shoes } = await supabase
      .from('products')
      .select('*')
      .eq('category', 'shoes')
      .limit(3);

    const { data: drinks } = await supabase
      .from('products')
      .select('*')
      .eq('category', 'drinks')
      .limit(3);

    if (shoes) setFeaturedShoes(shoes);
    if (drinks) setFeaturedDrinks(drinks);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Navigation */}
      <div className="absolute top-0 left-0 right-0 z-50 px-6 py-4 flex items-center justify-end">
        <LanguageSwitcher />
      </div>

      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[350px] overflow-hidden bg-gradient-to-br from-teal-600 to-teal-800">
        <div className="relative h-full flex flex-col items-center justify-center text-center px-6 text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('Välkommen Till')}</h1>
          <p className="text-4xl md:text-5xl font-bold">{t('MUDO Onlinebutik')}</p>
        </div>
      </div>

      {/* Categories */}
      <div className="px-6 py-12">
        <div className="grid grid-cols-2 gap-4 max-w-4xl mx-auto">
          <Link
            to="/products?category=snacks"
            className="relative h-48 rounded-2xl overflow-hidden shadow-lg group"
          >
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/876e3ff98c40433b6a9ba7ec125248f3/0a61a9bba4ca2b3667b824f63c1543ee.png"
                alt="Snacks"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            <div className="relative h-full flex flex-col justify-end p-6">
              <h3 className="text-white text-2xl font-bold">Snacks</h3>
            </div>
          </Link>

          <Link
            to="/products?category=drinks"
            className="relative h-48 rounded-2xl overflow-hidden shadow-lg group"
          >
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/876e3ff98c40433b6a9ba7ec125248f3/2c4f3df47e8068a13e294ea5f8b0b905.png"
                alt="Drinks"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            <div className="relative h-full flex flex-col justify-end p-6">
              <h3 className="text-white text-2xl font-bold">Drycker</h3>
            </div>
          </Link>

          <Link
            to="/products?category=icecream"
            className="relative h-48 rounded-2xl overflow-hidden shadow-lg group"
          >
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/876e3ff98c40433b6a9ba7ec125248f3/121c685b6591c0bce480484388b43c70.jpeg"
                alt="Ice Cream"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            <div className="relative h-full flex flex-col justify-end p-6">
              <h3 className="text-white text-2xl font-bold">Glass</h3>
            </div>
          </Link>

          <Link
            to="/products?category=uniformer"
            className="relative h-48 rounded-2xl overflow-hidden shadow-lg group"
          >
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/876e3ff98c40433b6a9ba7ec125248f3/9b7d88ed541aefd4ee0a84ade573984c.png"
                alt="Uniformer"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            <div className="relative h-full flex flex-col justify-end p-6">
              <h3 className="text-white text-2xl font-bold">{t('Uniformer')}</h3>
            </div>
          </Link>
        </div>
      </div>

      {/* Featured Shoes */}
      {/* <div className="px-6 py-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">{t('featured.shoes')}</h2>
            <Link to="/products?category=shoes" className="text-teal-600 font-semibold whitespace-nowrap">
              {t('common.viewAll')} <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-product-shop>
            {featuredShoes.map(product => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="bg-gray-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
              >
                <div className="relative w-full h-64">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-900 mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-teal-600">{product.price} kr</div>
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-star-fill text-yellow-500 mr-1"></i>
                      {product.rating}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div> */}

      {/* Featured Drinks */}
      {/* <div className="px-6 py-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">{t('featured.drinks')}</h2>
            <Link to="/products?category=drinks" className="text-teal-600 font-semibold whitespace-nowrap">
              {t('common.viewAll')} <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {featuredDrinks.map((product) => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow"
              >
                <div className="aspect-square relative overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-teal-600 font-bold text-lg">{product.price} kr</span>
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-yellow-400 text-sm"></i>
                      <span className="text-sm text-gray-600">{product.rating}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div> */}

      {/* CTA Section */}
      {/* <div className="px-6 py-16 bg-teal-600 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">{t('MUDO Academy')}</h2>
          <p className="text-lg mb-8 text-teal-50">{t('Building Future Heroes')}</p>
          <Link
            to="/products"
            className="inline-block bg-white text-teal-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap"
          >
            {t('cta.button')}
          </Link>
        </div>
      </div> */}

      <MobileNav />
    </div>
  );
}